import { Dropdown, Tooltip } from 'antd';
import type { MenuProps, DropdownProps } from 'antd';
import { SortAscendingOutlined } from '@ant-design/icons';
import styles from './SortDropdown.module.css';

export type SortKey = 'priority' | 'date' | 'name';

interface SortDropdownProps {
  value: SortKey;
  onChange: (value: SortKey) => void;
}

const SORT_LABELS: Record<SortKey, string> = {
  priority: 'Priority',
  date: 'Date',
  name: 'Name',
};

const items: MenuProps['items'] = [
  { key: 'priority', label: 'Priority' },
  { key: 'date', label: 'Date' },
  { key: 'name', label: 'Name' },
];

export default function SortDropdown({ value, onChange }: SortDropdownProps) {
  const handleClick: MenuProps['onClick'] = ({ key }) => {
    onChange(key as SortKey);
  };

  const dropdownProps: DropdownProps = {
    menu: { items, onClick: handleClick, selectedKeys: [value] },
    trigger: ['click'],
    placement: 'bottomRight',
  };

  return (
    <Dropdown {...dropdownProps}>
      <Tooltip title={`Sort: ${SORT_LABELS[value]}`} placement="bottom">
        <button
          type="button"
          className={styles.trigger}
          aria-label={`Sort by ${SORT_LABELS[value]}`}
        >
          <SortAscendingOutlined className={styles.icon} />
        </button>
      </Tooltip>
    </Dropdown>
  );
}
